import { render, staticRenderFns } from "./PreiserfassungDetail.vue?vue&type=template&id=3a91c75c&"
import script from "./PreiserfassungDetail.vue?vue&type=script&lang=js&"
export * from "./PreiserfassungDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports